(ns dre.pages.admin.client-download.views
  (:require
   [dre.components.icon :refer [fa-icon]]
   [dre.pages.admin.views :refer [nav-tabs]]
   [dre.pages.admin.client-download.events :as client-download]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(def component-name :admin-client-download)

(defn view
  []
  (let [loading? @(rf/subscribe [::client-download/loading?])]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :nav)}
      [nav-tabs]]
     [:div
      {:class (bem/be component-name :content)}
      [:div
       "Sanofi Tags:"]
      [:button.button.button--brand
       {:class (when loading? :button--disabled)
        :on-click #(when-not loading?
                     (rf/dispatch [::client-download/download-sanofi-csv]))}
       (if loading?
         [fa-icon :spinner {:spin true}]
         [fa-icon :download])
       "CSV"]]
     (when loading?
       [:div
        {:class (bem/be component-name :alert)}
        "Please be patient, it might take a couple of minutes to download..."])]))
